import ExplainWithAiResult from './ExplainWithAiResult';
import { LlmSubjectKind } from '../../utils/apollo/graphqlSchema';
import { useExplainEntityWithAiModel } from './index';

interface IProps {
  subjectKind: LlmSubjectKind;
}
const DummyExplainWithAiPanel = ({ subjectKind }: IProps) => {
  const {
    loading,
    toggleSection,
    sections,
    text,
    richText,
    explain,
    // updatedAt
  } = useExplainEntityWithAiModel({
    subjectId: null,
    subjectKind,
    takeScreenshot: false,
    schemaId: null,
  });

  return (
    <ExplainWithAiResult
      entityLoading={false}
      currentResult={text}
      currentResultRichText={richText}
      explain={explain}
      loading={loading}
      sections={sections}
      toggleSection={toggleSection}
      subjectKind={subjectKind}
      subjectId={null}
    />
  );
};

export default DummyExplainWithAiPanel;
